var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 88",
    style: {
      enableBackground: "new 0 0 58 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1373E6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,1.6v2.8C37.3,2.6,33.3,1.6,29,1.6c-14.8,0-26.8,12-26.8,26.9c0,14.9,12,26.9,26.8,26.9 c14.8,0,26.8-12,26.8-26.9V1.6H40.9z M29,16.7c6.5,0,11.8,5.3,11.8,11.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8 C17.2,22,22.5,16.7,29,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,71.3c-6.5,0-11.8-5.3-11.8-11.9h-15c0,14.9,12,26.9,26.8,26.9c14.8,0,26.8-12.1,26.8-26.9h-15 C40.8,66,35.5,71.3,29,71.3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandMark);
export default __webpack_public_path__ + "static/media/brandMark.ce2d15c3.svg";
export { ForwardRef as ReactComponent };